module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f05870a469bb80ae0aad61585c4f5dd3.png";